import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import DecorativeImageHighlight from '../../../../components/decorativeImageHighlight';
// images
import graphic1Webp from './images/balance-sheet-graphic.webp';
import graphic2Webp from './images/retirement-strategy-breakdown-graphic.webp';
import graphic3Webp from './images/asset-allocation-graphic.webp';
// styles
import {
  ColStyled,
  ColStyledHighlightContainer,
  RowStyled,
  TypographyStyled,
} from './styles';

export default () => (
  <SectionContainer
    id='financial-planning-product-intro'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        medium={8}
        align='center'>
        <Typography
          component='h2'
          nextElement='typography'>
          Let&#39;s create your financial plan.
          <TypographyStyled
            component='span'
            nextElement='typography'
            block>
            Here&#39;s how we <WidowBlock>do it.</WidowBlock>
          </TypographyStyled>
        </Typography>
        <Typography
          align='left'
          nextElement='graphic'>
          Better conversations can uncover opportunities that others often overlook and can lead to a better plan. Your plan is built specifically for you, so no two are alike. Together with your financial advisor, you&#39;ll look at:
        </Typography>
      </Col>
    </Row>
    {/* START DECORATIVE IMAGES */}
    <RowStyled align='center'>
      <ColStyled medium={4}>
        <Row>
          <ColStyledHighlightContainer
            xsmall={4}
            medium={12}>
            <DecorativeImageHighlight
              tagText='1'
              image={graphic1Webp}
              imageAlt='Tablet displaying a balance sheet graphic'
              firstChild
            />
          </ColStyledHighlightContainer>
          <Col
            xsmall={8}
            medium={12}>
            <Typography
              component='h3'
              nextElement='typography'>
              Where you are now
            </Typography>
            <Typography disableBottomPadding>
              Wherever you are today, let&#39;s start there. With a holistic view of your finances, you&#39;ll see exactly where you stand now and where to make the right moves for your money.
            </Typography>
          </Col>
        </Row>
      </ColStyled>
      <ColStyled medium={4}>
        <Row>
          <ColStyledHighlightContainer
            xsmall={4}
            medium={12}>
            <DecorativeImageHighlight
              tagText='2'
              image={graphic2Webp}
              imageAlt='Tablet displaying a retirement strategy graphic'
            />
          </ColStyledHighlightContainer>
          <Col
            xsmall={8}
            medium={12}>
            <Typography
              component='h3'
              nextElement='typography'>
              Where you want to go
            </Typography>
            <Typography disableBottomPadding>
              No matter what&#39;s next for you, your advisor will look at your goals&#8212;and uncover any blind spots and opportunities&#8212;so you can get closer to them.
            </Typography>
          </Col>
        </Row>
      </ColStyled>
      <ColStyled
        medium={4}
        disableBottomPadding>
        <Row>
          <ColStyledHighlightContainer
            xsmall={4}
            medium={12}>
            <DecorativeImageHighlight
              tagText='3'
              image={graphic3Webp}
              imageAlt='Tablet displaying an asset allocation graphic'
              lastChild
            />
          </ColStyledHighlightContainer>
          <Col
            xsmall={8}
            medium={12}>
            <Typography
              component='h3'
              nextElement='typography'>
              Solutions to help take <WidowBlock>you there</WidowBlock>
            </Typography>
            <Typography disableBottomPadding>
              Each recommendation&#8212;which could include{' '}
              <Link
                id='financial-planning-product-intro-investments-link'
                variant='primaryDeemphasize'
                linkUrl='/investments/'>
                investments
              </Link>
              {' '}for growth potential,{' '}
              <Link
                id='financial-planning-product-intro-insurance-link'
                variant='primaryDeemphasize'
                linkUrl='/insurance/'>
                insurance
              </Link>
              {' '}for protection, and{' '}
              <Link
                id='financial-planning-product-intro-annuities-link'
                variant='primaryDeemphasize'
                linkUrl='/annuities/'>
                annuities
              </Link>
              {' '}for retirement income&#8212;is designed to reinforce each other and fit your goals.
            </Typography>
          </Col>
        </Row>
      </ColStyled>
    </RowStyled>
    <Row>
      <Col align='center'>
        <Typography
          component='h3'
          nextElement='button'>
          Ready to get started with <WidowBlock>financial planning&#63;</WidowBlock>
        </Typography>
        <Link
          id='financial-planning-product-intro-cta-fafa'
          variant='buttonLinkPrimary'
          ariaLabel='get matched with a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Get matched with an advisor
        </Link>
      </Col>
    </Row>
  </SectionContainer>
);
